import { render, staticRenderFns } from "./SignUpFailure.vue?vue&type=template&id=60446cd7&scoped=true&"
import script from "./SignUpFailure.vue?vue&type=script&lang=js&"
export * from "./SignUpFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60446cd7",
  null
  
)

export default component.exports